import {Component, Input, OnInit} from '@angular/core';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {RoutesStorage} from '@helpers/routes.helper';

@Component({
    selector: 'app-working-objects-list',
    templateUrl: 'working-objects-list.component.html'
})

export class WorkingObjectsListComponent implements OnInit {

    @Input() workingObjects: EquipmentCardInterfaces.Card.WorkingObjectInfo[] = [];
    public showedObjects: EquipmentCardInterfaces.Card.WorkingObjectInfo[] = [];
    public collapsedObjects: EquipmentCardInterfaces.Card.WorkingObjectInfo[] = [];

    public collapsed = true;

    /**
     * Сколько показывать элементов не свернутыми
     */
    private showingCount = 1;

    /**
     * Сворачивать элементы только если их больше заданного числа
     */
    private countForCollapsing = 1;

    constructor() {
    }

    ngOnInit() {
        /**
         * Если элементов не больше заданного допустимого порога, то показываем все сразу
         */
        if (this.workingObjects.length <= this.countForCollapsing) {
            this.showedObjects = this.workingObjects;
            this.collapsedObjects = [];
        } else {
            this.showedObjects = this.workingObjects.slice(0, this.showingCount);
            this.collapsedObjects = this.workingObjects.slice(this.showingCount);
        }
    }

    objectViewLink(id: number) {
        return RoutesStorage.WorkingObject.view(id);
    }

    toggle() {
        this.collapsed = !this.collapsed;
    }
}
